import {
  AdminResourceDictPropertiesListRequest,
  ResourceDictPropertyOptionValue,
  AdminResourcesDictPropertyOptionsRequest,
  AdminResourcesListRequest,
  AdminResourcesListResponse,
  AdminResourceUpdateRequest,
  AdminResourceUpdateResponse,
  AdminResourceDictPropertiesListResponse,
  AdminResourcesReadRequest,
  AdminResourcesReadResponse,
  AdminResourceRecalculatePropertiesResponse,
  AdminResourceUpdateExternalIdRequest,
  ResourceId,
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';
import { useTranslationStore } from '@/stores/translation';

export default class ResourceManagementService {
  constructor() {}

  /**
   * Getter dla currentLanguage wybranego przez uzytkownika
   */
  public get currentLanguage(): string {
    const translationStore = useTranslationStore();
    return translationStore.currentLanguage;
  }

  public readResource(request: AdminResourcesReadRequest): Promise<AxiosResponse<AdminResourcesReadResponse>> {
    return axios.post<AdminResourcesReadResponse>('/api/admin/resources/read', request);
  }

  public listResources(listRequest: AdminResourcesListRequest): Promise<AxiosResponse<AdminResourcesListResponse>> {
    return axios.post<AdminResourcesListResponse>('/api/admin/resources', listRequest);
  }

  public updateResource(uuid: string, updateRequest: AdminResourceUpdateRequest): Promise<AxiosResponse<AdminResourceUpdateResponse>> {
    return axios.put<AdminResourceUpdateResponse>(`/api/admin/resources/${encodeURIComponent(uuid)}`, updateRequest);
  }

  public listAllPropertiesDict(): Promise<AxiosResponse<AdminResourceDictPropertiesListResponse>> {
    const request: AdminResourceDictPropertiesListRequest = {
      criteria: {
        code: null,
        description: null,
      },
    };
    return this.listPropertiesDict(request, this.currentLanguage);
  }

  public listPropertiesDict(
    request: AdminResourceDictPropertiesListRequest,
    lang: string
  ): Promise<AxiosResponse<AdminResourceDictPropertiesListResponse>> {
    return axios.post<AdminResourceDictPropertiesListResponse>(`/api/admin/resources/dict/properties/list?lang=${lang}`, request);
  }

  public recalculateProperties(uuid: string): Promise<AxiosResponse<AdminResourceRecalculatePropertiesResponse>> {
    return axios.post<AdminResourceRecalculatePropertiesResponse>(`/api/admin/resources/${encodeURIComponent(uuid)}/recalculate-properties`);
  }

  public updateExternalId(uuid: string, externalId: string): Promise<AxiosResponse<void>> {
    const request: AdminResourceUpdateExternalIdRequest = { externalId };
    return axios.put<void>(`/api/admin/resources/${encodeURIComponent(uuid)}/external-id`, request);
  }

  public listPropertyOptions(
    propertyCode: string,
    userText: string,
    limit: number
  ): Promise<AxiosResponse<ResourceDictPropertyOptionValue[]>> {
    const payload: AdminResourcesDictPropertyOptionsRequest = {
      userText,
      propertyCode,
      limit,
    };
    return axios.post<ResourceDictPropertyOptionValue[]>('/api/admin/resources/dict/properties/options', payload);
  }
}
